<template>
  <div class="container">
    <div class="header-img">
      <img src="../../assets/images/tunnel/header.png" alt="">
    </div>
    <div class="content">
      <div action=""  class="custom-form">
        <img class="phone-img" src="../../assets/images/tunnel/phone.png" alt="">
        <div class="phone-desc">
          <p class="desc-1">恭喜您！领取成功</p>
          <p class="desc-2">当前领取账户：{{phone}}</p>
        </div>
        <img class="coupon-img" src="../../assets/images/tunnel/sucjuan.png" alt="">
        <div class="form-item form-item-button">
          <button class="form-button" @click="handleDown">下载便捷青岛使用</button>
        </div>
      </div>
      <rule-page></rule-page>
    </div>
  </div>
</template>

<script>
import RulePage from './rule'

export default {
  name: 'tunnelregister',
  components: {
    RulePage: RulePage
  },
  data () {
    return {
      phone: ''
    }
  },
  mounted () {
    this.phone = this.$route.query.phone
  },
  methods: {
    handleDown (e) {
      e.preventDefault()
      window.location.href = 'https://a.app.qq.com/o/simple.jsp?pkgname=com.bsit.coband'
    }
  }
}

</script>
<style lang='scss' scoped>
.container {
  height: 100%;
  background-size: 100%;
  background: #d5ecfe;
}
.header-img {
  img {
    width: 100%;
  }
}
.coupon-img {
  img {
    width: 100%;
  }
}
.content {
  padding: 20px;
  background: url('../../assets/images/tunnel/bg.png');
}
.custom-form {
  display: flex;
  flex-direction: column;
  justify-content: center;
  margin-bottom: 20px;
  border-radius: 10px;
  background: #fff;
}
.form-item {
  display: flex;
  align-items: center;
  padding:  10px 15px;
  overflow: hidden;
  &:last-child {
    border-bottom: 1px solid  transparent;
  }
}
.form-item.form-item-button {
  padding: 20px 0  10px;
}
.phone-img {
  margin: 20px auto 20px;
  width: 70px;
}
.phone-desc {
  line-height: 1.6;
  text-align: center;
}
.coupon-img {
  height: 80px;
  max-width: 305px;
  margin: 20px auto 5px;
}
.desc-1 {
  font-size: 16px;
  color: #ff8200;
}
.desc-2 {
  font-size: 14px;
  color: #282828;
}

.form-button {
  box-sizing: border-box;
  width: 90%;
  margin: 0 auto 12px;
  padding: 8px 5px;
  font-size: 16px;
  color: #fff;
  border-radius: 20px;
  outline: none;
  background-image: linear-gradient(176deg, #0fa0ff 0%, #2d7aff 99%);
}
</style>
